import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import mapboxgl from 'mapbox-gl';
import useBranch from 'client/hooks/useBranch';

const SrOpenStreetMap = ({ coordinates, initialZoom, onMapClick }) => {
  const { mapboxAccessToken } = useBranch({
    mapboxAccessToken: ['env', 'MAPBOX_ACCESS_TOKEN'],
  });

  const mapContainer = useRef(null);
  const map = useRef(null);
  const [lng, setLng] = useState(coordinates[0]);
  const [lat, setLat] = useState(coordinates[1]);
  const [zoom, setZoom] = useState(initialZoom);

  useEffect(() => {
    if (mapboxAccessToken && !mapboxgl.accessToken) {
      mapboxgl.accessToken = mapboxAccessToken;
    }
    if (!mapboxAccessToken || map.current) {
      return;
    }
    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: 'mapbox://styles/mapbox/streets-v11',
      center: [lng, lat],
      zoom: zoom,
    });

    map.current.on('move', () => {
      setLng(map.current.getCenter().lng.toFixed(4));
      setLat(map.current.getCenter().lat.toFixed(4));
      setZoom(map.current.getZoom().toFixed(2));
    });

    const markerEl = document.createElement('div');
    markerEl.className = 'SrOpenStreetMapMarker';
    markerEl.style.width = '68px';
    markerEl.style.height = '81px';
    markerEl.style.backgroundSize = '100%';
    markerEl.onClick = onMapClick;

    new mapboxgl.Marker(markerEl)
      .setLngLat(coordinates)
      .addTo(map.current);
  });

  if (!mapboxAccessToken) {
    return null;
  }

  return (
    <div className='section map'>
      <div
        className='sectionInnerContainer'
        stye={{
          height: '100%',
          width: '100%',
        }}
        onClick={onMapClick}
        ref={mapContainer}
      />
    </div>
  );
};

SrOpenStreetMap.propTypes = {
  coordinates: PropTypes.array.isRequired,
  initialZoom: PropTypes.number,
};

SrOpenStreetMap.defaultProps = {
  initialZoom: 12,
};

SrOpenStreetMap.displayName = 'SrOpenStreetMap';

export default SrOpenStreetMap;
